import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { formatFileSize, formatDate, getStatusColor, getStatusText } from '../utils/helpers';
import SidePanel from './ui/SidePanel';

interface TaskDetailPanelProps {
  isOpen: boolean;
  onClose: () => void;
  task: any;
}

export default function TaskDetailPanel({ isOpen, onClose, task }: TaskDetailPanelProps) {
  return (
    <SidePanel
      isOpen={isOpen}
      onClose={onClose}
      title="任务详情"
      icon={<InformationCircleIcon className="h-5 w-5 text-blue-400" />}
    >
      {task ? <TaskContent task={task} /> : (
        <div className="flex flex-col items-center justify-center h-full text-zinc-500">
          <InformationCircleIcon className="h-12 w-12 mb-4 opacity-20" />
          <p>请选择一个任务以查看详情</p>
        </div>
      )}
    </SidePanel>
  );
}

function TaskContent({ task }: { task: any }) {
  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-xs font-bold uppercase tracking-[0.1em] text-zinc-500 mb-4">基本信息</h3>
        <dl className="space-y-4">
          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">任务 ID</dt>
            <dd className="text-sm font-medium text-zinc-200 font-mono">{task.id}</dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">文件名</dt>
            <dd className="text-sm font-medium text-zinc-200">{task.file_name}</dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">文件大小</dt>
            <dd className="text-sm font-medium text-zinc-200">{formatFileSize(task.file_size)}</dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">状态</dt>
            <dd>
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold ${getStatusColor(task.status)} ring-1 ring-inset`}>
                {getStatusText(task.status)}
              </span>
            </dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">用户 ID</dt>
            <dd className="text-sm font-medium text-zinc-200 font-mono">{task.user_id}</dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">Chat ID</dt>
            <dd className="text-sm font-medium text-zinc-200 font-mono">{task.chat_id}</dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">消息 ID</dt>
            <dd className="text-sm font-medium text-zinc-200 font-mono">{task.msg_id}</dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">认领实例</dt>
            <dd className="text-sm font-medium text-zinc-200 font-mono">{task.claimed_by || '无'}</dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">创建时间</dt>
            <dd className="text-sm font-medium text-zinc-200 font-mono">{formatDate(task.created_at)}</dd>
          </div>

          <div className="flex flex-col gap-y-1">
            <dt className="text-xs font-medium text-zinc-500 uppercase tracking-wider">更新时间</dt>
            <dd className="text-sm font-medium text-zinc-200 font-mono">{formatDate(task.updated_at)}</dd>
          </div>
        </dl>
      </div>

      {task.status === 'failed' && (task.error_msg || task.error_message) && (
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.1em] text-rose-500/70 mb-4">错误信息</h3>
          <div className="rounded-xl bg-rose-500/5 p-4">
            <pre className="font-mono text-xs leading-relaxed text-rose-400/80 whitespace-pre-wrap break-all">
              {task.error_msg || task.error_message}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
}